import * as types from 'constants/actionTypes';

/**
 * @param {Object} model - Need to contain 2 props. prop year - int and prop branch int
 */
export const getAnnualSales = model => {
    return { type: types.GET_ANNUAL_SALES, model };
};

export const getTransactionSummary = model => {
    return { type: types.GET_EMPLOYEE_ACTVITY, model };
};

export const getHourlySales = model => {
    return { type: types.GET_HOURLY_SALES, model };
};

export const getHourlySalesDateRange = model => {
    return { type: types.GET_HOURLY_SALES_DATE_RANGE, model };
};

export const getHourlySalesSecondary = model => {
    return { type: types.GET_HOURLY_SALES_SECONDARY, model };
};

export const getBudtenderAvgSales = model => {
    return { type: types.GET_TRANSACTION_SUMMARY_BY_BUDTENDER, model };
};

export const getProductVelocity = model => {
    return { type: types.GET_PRODUCT_VELOCITY, model };
};

export const getWarehouseTransferReport = model => {
    return { type: types.GET_WAREHOUSE_TRANSFER_REPORT, model };
};

export const getAggregateBranchesReport = model => {
    return { type: types.GET_AGGREGATE_BRANCHES_REPORT, model };
};

export const getDiscountReport = model => {
    return { type: types.GET_DISCOUNT_REPORT, model };
};

export const getCombinedSalesReport = model => {
    return { type: types.GET_COMBINED_SALES_REPORT, model };
};

export const getBudgetPlannerReport = model => {
    return { type: types.GET_BUDGET_PLANNER_REPORT, model };
};

export const getReorderReport = model => {
    return { type: types.GET_REORDER_REPORT, model };
};

export const getEndOfDayReport = model => {
    return { type: types.GET_END_OF_DAY_REPORT, model };
};

export const getProductSales = model => {
    return { type: types.GET_PRODUCT_SALES, model };
};

export const getProductRanking = model => {
    return { type: types.GET_PRODUCT_RANKING, model };
};

export const getMonthlyProductSales = model => {
    return { type: types.GET_MONTHLY_PRODUCT_SALES, model };
};

export const getDestroyedProductReport = model => {
    return { type: types.GET_DESTROYED_PRODUCT_REPORT, model };
};

export const getEmployeeTimesheet = model => {
    return { type: types.GET_EMPLOYEE_TIMESHEET, model };
};

export const getEmployeeHours = model => {
    return { type: types.GET_EMPLOYEE_HOURS, model };
};

export const getDailyCashSummary = model => {
    return { type: types.GET_DAILY_CASH_SUMMARY, model };
};

export const getCustomerSales = model => {
    return { type: types.GET_CUSTOMER_SALES, model };
};

export const getSalesByType = model => {
    return { type: types.GET_SALES_BY_TYPE, model };
};

export const getDiscrepancyReport = model => {
    return { type: types.GET_DISCREPANCY_REPORT, model };
};

export const getManualInventoryChange = model => {
    return { type: types.GET_MANUAL_INVENTORY_CHANGE, model };
};

export const getSalesSummary = model => {
    return { type: types.GET_SALES_SUMMARY, model };
};

export const getTransactionSaleSummary = model => {
    return { type: types.GET_TRANSACTION_SALES_SUMMARY, model };
};

export const getDailySalesReport = model => {
    return { type: types.GET_SALES_DAILY_REPORT, model };
};

export const getMonthlySalesReport = model => {
    return { type: types.GET_SALES_MONTHLY_REPORT, model };
};

export const getDailyProfitReport = model => {
    return { type: types.GET_PROFIT_DAILY_REPORT, model };
};

export const getGmroiReport = model => {
    return { type: types.GET_GMROI_REPORT, model };
};

export const getMonthlyProfitReport = model => {
    return { type: types.GET_PROFIT_MONTHLY_REPORT, model };
};

export const getShoppingTrend = model => {
    return { type: types.GET_SHOPPING_TREND, model };
};

export const getYearlySalesReport = model => {
    return { type: types.GET_SALES_YEARLY_REPORT, model };
};

export const getYearlyProfitReport = model => {
    return { type: types.GET_PROFIT_YEARLY_REPORT, model };
};

export const getRevenueReport = model => {
    return { type: types.GET_REVENUE_REPORT, model };
};

export const getProfitReport = model => {
    return { type: types.GET_PROFIT_REPORT, model };
};

export const getProductPriceChangeReport = model => {
    return { type: types.GET_PRODUCT_PRICE_CHANGE_REPORT, model };
};

export const getTaxSummary = model => {
    return { type: types.GET_TAX_SUMMARY, model };
};

export const getPurchaseOrderReport = model => {
    return { type: types.GET_PURCHASE_ORDER_REPORT, model };
};

export const getSellThroughReport = model => {
    return { type: types.GET_SELL_THROUGH_REPORT, model };
};

export const getInventoryLevel = model => {
    return { type: types.GET_INVENTORY_LEVEL, model };
};

export const getDemographicReport = branch => {
    return { type: types.GET_DEMOGRAPHIC_REPORT, branch };
};

export const getInventoryAge = model => {
    return { type: types.GET_INVENTORY_AGE, model }
}

export const getRestockByCaps = model => {
    return { type: types.GET_RESTOCK_BY_CAPS, model }
}

export const getPriceTracker = model => {
    return { type: types.GET_PRICE_TRACKER, model };
};

export const getTHCCBDTracker = model => {
    return { type: types.GET_THCCBD_TRACKER, model };
};

export const getGeneralReport = model => {
    return { type: types.GET_GENERAL_REPORT, model };
};

export const getCreditPayments = model => {
    return { type: types.GET_CREDIT_PAYMENTS, model };
};

export const getGiftCardBalance = model => {
    return { type: types.GET_GIFT_CARD_BALANCE, model };
};

export const getDeliveryReport = model => {
    return { type: types.GET_DELIVERY_REPORT, model };
};


// Added for Shift by Employee Report (by Kate 2018-04-03 2:14PM)
export const getShiftByEmployee = model => {
    return { type: types.GET_SHIFT_BY_EMPLOYEE, model };
};

export const getCategorySales = model => {
    return { type: types.GET_CATEGORY_SALES, model };
};

// Added for Shift by Day Report (by Kate 2018-05-02 1:40PM)
export const getShiftByDay = model => {
    return { type: types.GET_SHIFT_BY_DAY, model };
};

export const getInventoryMovement = (model) => {
    return { type: types.GET_INVENTORY_MOVEMENT_REPORT, model };
}

export const getInventoryLogReport = (model) => {
    return { type: types.GET_INVENTORY_LOG_REPORT, model };
}

export const getInventorySnapShot = (model) => {
    return { type: types.GET_INVENTORY_SNAP_SHOT, model }
};

export const getMonthlyInventory = (model) => {
    return { type: types.GET_MONTHLY_INVENTORY, model }
};

export const getInventorySnapShotProductView = (model) => {
    return { type: types.GET_INVENTORY_SNAP_SHOT_PRODUCT_VIEW, model }
}

export const getAggregateInventoryLevel = (model) => {
    return { type: types.GET_AGGREGATE_INVENTORY_LEVEL, model }
};

export const getAggregateSales = (model) => {
    return { type: types.GET_AGGREGATE_SALES, model }
};

export const getAggregateInventory = (model) => {
    return { type: types.GET_AGGREGATE_INVENTORY, model }
};

export const downloadSalesSummary = (branchId) => {
    return { type: types.DOWNLOAD_SALESSUMMARY, branchId };
};

export const downloadSalesSummarySuccess = (data) => {
    return { type: types.DOWNLOAD_SALESSUMMARY_SUCCESS, data };
};

export const downloadFederalReport = model => {
    return { type: types.DOWNLOAD_FEDERALREPORT, model }
};

export const downloadFederalReportSuccess = data => {
    return { type: types.DOWNLOAD_FEDERALREPORT_SUCCESS, data }
};


export const downloadError = (error) => {
    return { type: types.DOWNLOAD_ERROR, error };
};

export function clearInventoryChart() {
    return { type: types.CLEAR_INVENTORY_CHART }
};

export const getBrandSales = (model) => {
    return { type: types.GET_BRAND_SALES, model }
};

export const getInstoreOnlineSales = (model) => {
    return { type: types.GET_INSTORE_ONLINE_SALES, model }
};

export const getOrderListSales = (model) => {
    return { type: types.GET_ORDER_LIST_SALES, model }
};

export const getCategoryProducts = model => {
    return { type: types.GET_CATEGORY_PRODUCTS, model };
};

export const getGiftCardReport = model => {
    return { type: types.GET_GIFT_CARD_REPORT, model };
};

export const getPurchaseOrderReceiver = model => {
    return { type: types.GET_PURCHASE_RECEIVER, model };
};

export const getSalesSummaryWithDetails = model => {
    return { type: types.GET_SALES_SUMMARY_WITH_DETAILS, model };
};

export const getAggregateBranchSalesInventory = model => {
    return { type: types.GET_AGGREGATE_BRANCH_SALES_INVENTORY, model };
};

export const getAuditReport = model => {
    return { type: types.GET_AUDIT_REPORT, model };
};

export const getUncountedReport = model => {
    return { type: types.GET_UNCOUNTED_REPORT, model };
};

export const getSageExportGuid = model => {
    return { type: types.GET_SAGE_EXPORT_GUID, model };
};

export const getInventoryAtDateGuid = model => {
    return { type: types.GET_INVENTORY_AT_DATE_GUID, model };
};

export const getCsvReport = (url, name, mode = "get") => {
    return { type: types.GET_CSV_REPORT, url, name, mode }
};

export const getProductList = (url, name) => {
    return { type: types.GET_PRODUCT_CATALOG_LIST, url, name }
};
